import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';
import ErrorBoundary from './ErrorBoundary';


if (process.env.NODE_ENV === "production") {
  window.onerror = () => true;
  window.onunhandledrejection = () => true;

}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </Router>
);



